/* eslint require-jsdoc: "off", curly: "error" */

'use strict';

const measures = require('./util/measures');

// Class Selectors
const pdVideoClass = '.nb-pd-video';

/**
 * Toggles the play/pause button state for a given video element.
 *
 * @param {HTMLVideoElement} video - The video element to control.
 * @param {boolean} paused - Indicates whether the video is paused.
 * @param {boolean} manuallyClicked - Indicates whether the button was clicked by the user
 */
function switchPlayPauseBtn(video, paused, manuallyClicked) {
    if (!video) {
        return;
    }

    const $playPauseControl = $($(video).siblings('.video-controls').find('.play-pause'));
    $playPauseControl.toggleClass('paused', paused);

    if (manuallyClicked) {
        const btnClass = paused ? '.btn-play' : '.btn-pause';
        const btn = $playPauseControl.find(btnClass)[0];
        if (btn) {
            btn.focus();
        }
    }
}

function initVideoControlEvents() {
    document.addEventListener('click', function (e) {
        if (e.target.matches('.play-pause') || e.target.matches('.btn-pause') || e.target.matches('.btn-play')) {
            e.preventDefault();
            const currentBtn = e.target;
            const nbPdVideo = currentBtn.closest(pdVideoClass);
            if (nbPdVideo) {
                const video = nbPdVideo.querySelector('video');
                if (video) {
                    if (video.paused) {
                        video.play();
                        switchPlayPauseBtn(video, false, true);
                    } else {
                        video.pause();
                        switchPlayPauseBtn(video, true, true);
                    }
                }
            }
        }
    });

    $('.volume').on('click', function (e) {
        e.preventDefault();
        var $currentBtn = $(this);
        var nbPdVideo = $currentBtn.closest(pdVideoClass);
        if (nbPdVideo && nbPdVideo.length) {
            var video = $(nbPdVideo).find('video');
            if (video && video.length) {
                video = video[0];
                if (video.muted) {
                    $currentBtn.removeClass('muted');
                } else {
                    $currentBtn.addClass('muted');
                }
                video.muted = !(video.muted);
            }
        }
    });
}

function isVideoVisible(video) {
    var x = 0;
    var y = 0;
    var w = video.offsetWidth;
    var h = video.offsetHeight;
    var r;
    var b;
    var visibleX;
    var visibleY;
    var visibleMultiplication;
    var visible;
    var parent;
    parent = video;
    while (parent && parent !== document.body) {
        x += parent.offsetLeft;
        y += parent.offsetTop;
        parent = parent.offsetParent;
    }
    r = x + w;
    b = y + h;
    visibleX = Math.max(0, Math.min(w, window.pageXOffset + window.innerWidth - x, r - window.pageXOffset));
    visibleY = Math.max(0, Math.min(h, window.pageYOffset + window.innerHeight - y, b - window.pageYOffset));
    visibleMultiplication = visibleX * visibleY;
    visible = visibleMultiplication / (w * h);
    return visible;
}

function instantiateProductVideos() {
    var videoWrappers = Array.from(document.querySelectorAll('.nb-video__product-js:not([data-scripted])'));
    var isMobileViewport = measures.isMobile();

    videoWrappers.forEach(function (element) {
        element.setAttribute('data-scripted', 'true');
        var autoPauseData = 'data-auto-pause';
        var video = element.getElementsByTagName('video')[0];
        var isProductVideo = video.getAttribute('data-isproductvideo') === 'true';
        var playable = 0;

        // determines whether the video will play with video load or play with scroll video into view
        if (!isProductVideo) {
            // at least 80% of the video element is visible in the viewport
            playable = 0.80;
        }

        function handleAutoPlay() {
            var visible = isVideoVisible(video);
            video.setAttribute('muted', true);

            var autoPaused = video.getAttribute(autoPauseData) === 'true';
            var manualControlsOnly = video.getAttribute('data-manual-controls') === 'true';

            if (visible > playable) {
                if (autoPaused && !manualControlsOnly) {
                    video.setAttribute(autoPauseData, false);
                } else {
                    // don't resume playing the video if the user manually paused it
                    return;
                }
                video.play();
                switchPlayPauseBtn(video, false);
            } else {
                if (!video.paused) {
                    video.setAttribute(autoPauseData, true);
                }
                video.setAttribute('muted', true);
                video.pause();
                switchPlayPauseBtn(video, true);
            }
        }

        if (isProductVideo && !isMobileViewport) {
            video.load();
            handleAutoPlay();
            // extra pause/play necessary for video to play on product image/video load
            video.play();
            switchPlayPauseBtn(video, false);
            video.muted = true;
        }

        if (!isProductVideo) {
            video.setAttribute(autoPauseData, true);
            window.addEventListener('scroll', handleAutoPlay, false);
            window.addEventListener('resize', handleAutoPlay, false);
            window.addEventListener('load', handleAutoPlay, false);
        }
    });
}

window.instantiateProductVideos = instantiateProductVideos;

$(document).ready(function () {
    instantiateProductVideos();
    document.addEventListener('content:updated', instantiateProductVideos);
    initVideoControlEvents();
});
